<div bsModal #documentHistoryModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="width:960px;">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="close()">&times;</button>
                <h4 class="modal-title" id="myModalLabel" style="display:inline-block">
                    <span>Document History &bull; </span>
                    <span>{{ document.ProductName }} | {{ document.FileName }}</span>
                </h4>
            </div>
            <div class="modal-body">
                <table class="table m-table table-bordered table-hover table-heading">
                    <colgroup>
                        <col style="width:400px;" />
                        <col style="width:100px;" />
                        <col style="width:100px;" />
                        <col style="width:auto;" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Product Name</span>
                                <br />
                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">File Name</span>
                            </th>
                            <th>
                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Version</span>
                                <br />
                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Updated</span>
                            </th>
                            <th>
                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Replaces</span>
                                <br />
                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Version</span>
                            </th>
                            <th>
                                <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Devices with outdated Document</span>
                            </th>
                        </tr>
                    </thead>
                </table>
                <div style="height:300px; overflow-y:scroll; margin-top:-20px;">
                    <table class="table m-table table-bordered table-hover table-heading" style="margin-bottom:0px;">
                        <colgroup>
                            <col style="width:400px;" />
                            <col style="width:100px;" />
                            <col style="width:100px;" />
                            <col style="width:auto;" />
                        </colgroup>
                        <tbody>
                            <tr *ngFor="let document of historyDocuments">
                                <td>
                                    <span>{{ document.FileName }}</span>
                                    <br />
                                    <span>{{ document.ProductName }}</span>
                                </td>
                                <td>
                                    <span>{{ document.Version }}</span>
                                    <br />
                                    <span>{{ document.VersionDate | amDateFormat: 'MM/DD/YYYY' }}</span>
                                </td>
                                <td>
                                    <span>{{ document.UpdateTo?.Version }}</span>
                                    <br />
                                    <span>{{ document.UpdateTo?.VersionDate | amDateFormat: 'MM/DD/YYYY' }}</span>
                                </td>
                                <td>
                                    <span>{{ document.DeviceDocuments?.length }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <!--<button type="button" class="btn btn-info" title="Revert all changes" data-bind="click: function () { $parent.revert(); }">Revert</button>
                <button type="button" class="btn btn-default" data-bind="click: function(event, event2){ return $parent.commit(event, event2);}, enable: ($data.isValid().length == 0)">Save</button>
                <button type="button" class="btn btn-warning" data-bind="click: function(){ $parent.undo();}">Cancel</button>-->
            </div>
        </div>
    </div>
</div>
